
import React, { useState } from "react";
import "./style/modal.css";
import Button from "../../button/button";
import DataUnitForm from "./dataUnitForm";
import { sendCallbackRequest } from "../../../api/form/form";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
import { assets } from "../../../assets/assets";
function Modal({ lang, show, onClose, type, villa }) {
  const translations = lang === "ar" ? ar : en;
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    residence: "",
    nationality: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await sendCallbackRequest({ ...formData, unit_id: villa?.id });
      onClose(); // تقفل الفورم
      // setShowSuccess(true); // تفتح مودال النجاح
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        residence: "",
        nationality: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { label: translations.firstName, name: "first_name", col: 6 },
    { label: translations.lastName, name: "last_name", col: 6 },
    { label: translations.email, name: "email", col: 6 },
    { label: translations.phone, name: "phone", col: 6 },
    { label: translations.residence, name: "residence", col: 6 },
    { label: translations.nationality, name: "nationality", col: 6 },
    { label: translations.message, name: "message", col: 12 },
  ];

  return (
    <>
      {/* الفورم */}
      {show && (
        <div className={`form-model ${lang === "ar" ? "rtl" : "ltr"}`}>
          <div
            className="modal fade show p-0"
            style={{ display: "block" }}
            onClick={onClose}
          >
            <div
              className="modal-dialog d-flex justify-content-center"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content- col-md-9">
                <div className="modal-header d-flex justify-content-center">
                  <img src={assets.X_form} alt="" onClick={onClose} className="close-btn" />
                  <p className="modal-title fs-6">{translations.title_form}</p>
                </div>

                {type === "interactive" && (
                  <div className="data-unit-interActive">
                    <DataUnitForm villa={villa} />
                  </div>
                )}

                <div className="modal-body py-0">
                  <div className="row">
                    {fields.map((field) => (
                      <div key={field.name} className={`col-md-${field.col}`}>
                        <div className="mb-3">
                          <label className="form-label mb-1">{field.label}</label>
                          {field.textarea ? (
                            <textarea
                              className="form-control"
                              name={field.name}
                              rows="3"
                              value={formData[field.name]}
                              onChange={handleChange}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control"
                              name={field.name}
                              value={formData[field.name]}
                              onChange={handleChange}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="modal-footer">
                  <Button
                    className="main-btn"
                    text={loading ? translations.loading : translations.send}
                    onClick={handleSubmit}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default Modal;


